import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { GOOGLE_STORE_URL, APPLE_STORE_URL } from "./config";

export const saveScrollCardPosition = () => {
  let cardPosition = window.pageYOffset || window.scrollY;
  localStorage.setItem("scrollPosition", cardPosition);
};

export const UseScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export const UseScrollToPeviousPosition = () => {
  const location = useLocation();
  const hasScrolled = useRef(false);

  useEffect(() => {
    let savedPosition = localStorage.getItem("scrollPosition");
    savedPosition = savedPosition ? Number(savedPosition) : 0;

    const prevPath = location.state?.prevPath || "";

    if (hasScrolled.current) return;
    hasScrolled.current = true; // for future renders to prevent duplicate runs

    if (prevPath === "/404") {
      /* NOTE: No need to reset scroll to top when returning to home/landing page — React Router remounts the component by default, starting at the top.*/
    } else if (prevPath.startsWith("/legal")) {
      window.scrollTo(0, 0);
      localStorage.removeItem("scrollPosition");
    } else if (savedPosition) {
      window.scrollTo(0, savedPosition);
      localStorage.removeItem("scrollPosition");
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
};

export const scrollToTopLegalTabLinks = () => {
  window.scrollTo(0, 0);
};

export const UseStickyNav = () => {
  useEffect(() => {
    const target = document.querySelector(".nav-header");
    const tabLinks = document.querySelector(".tab-links");
    const tabLinksNav = document.querySelector(".tab-links__nav");

    if (!target || !tabLinks || !tabLinksNav) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          tabLinks.classList.remove("tab-links--sticky");
          tabLinksNav.classList.remove("tab-links__nav--sticky");
        } else {
          tabLinks.classList.add("tab-links--sticky");
          tabLinksNav.classList.add("tab-links__nav--sticky");
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(target);

    return () => {
      observer.disconnect();
    };
  }, []);
};

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
};

export default useWindowWidth;

// Highlights specific phrases in a text by wrapping them in <strong>
export const highlightPhrases = (text, phrasesToHighlight) => {
  if (!phrasesToHighlight || phrasesToHighlight.length === 0) return text;

  // Escapes special characters for safe use in regex
  const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  // Build regex to match any of the phrases (case-insensitive)
  // -- contains cleaned/escaped sentences to highlight
  const regex = new RegExp(
    `(${phrasesToHighlight.map(escapeRegExp).join("|")})`,
    "gi",
  );

  // Split the text, keeping phrases to highlight
  const parts = text.split(regex);

  // Wrap phrases to highlight in <strong>, leave others as-is
  return parts.map((part, i) =>
    phrasesToHighlight.includes(part) ? <strong key={i}>{part}</strong> : part,
  );
};

// DETECT OS -- to serve appropriate app store
export const getMobileOS = () => {
  const userAgent = navigator.userAgent || navigator.vender || window.opera;
  if (/android/i.test(userAgent)) return "android";
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "ios";

  return "other";
};

export const handleDownloadClick = (e) => {
  e.preventDefault();
  const os = getMobileOS();

  const url =
    os === "android"
      ? GOOGLE_STORE_URL
      : os === "ios"
        ? APPLE_STORE_URL
        : "https://hikotest.netlify.app/";

  window.location.href = url;
};
